module.exports = __webpack_public_path__ + "static/media/pin-shadow.d337191b.svg";